const isDev = import.meta.env.DEV;

const noop = () => {};

const createLogger = () => {
  if (!isDev) {
    return { info: noop, warn: noop, error: noop, state: noop };
  }

  return {
    info: (msg: string, ...args: unknown[]) => console.log(`[ForgeView] ${msg}`, ...args),
    warn: (msg: string, ...args: unknown[]) => console.warn(`[ForgeView] ${msg}`, ...args),
    error: (msg: string, ...args: unknown[]) => console.error(`[ForgeView] ${msg}`, ...args),
    state: (label: string, state: unknown) => console.log(`[ForgeView State] ${label}:`, state),
  };
};

export const log = createLogger();
